import { render } from "./AdminEmployeesCustomerDetail.vue?vue&type=template&id=7f61a6c4"
import script from "./AdminEmployeesCustomerDetail.vue?vue&type=script&lang=js"
export * from "./AdminEmployeesCustomerDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__